const translations = {
	title: [
		'Richiedi disponibilità senza impegno!',
		'Request availability without obligation!',
		'Verfügbarkeit ohne Verpflichtung anfordern!',
	],
	popover_title: [
		'Sei interessato a %%MINISITE_NAME%%?',
		'Are you interested in %%MINISITE_NAME%%?',
		'Interessieren Sie sich für %%MINISITE_NAME%%?',
	],
	popover_subtitle: [
		'Invia una richiesta di disponibilità o di informazioni!',
		'Send a request for availability or information!',
		'Senden Sie eine Anfrage zur Verfügbarkeit oder Informationen!',
	],
}

export function getTranslations(langId) {
	const data = {}

	for (const [key, value] of Object.entries(translations)) {
		data[key] = value[langId - 1]
	}

	return data
}
